import { motion } from "framer-motion";
import styled from "styled-components";

export const ContentMotion = styled(motion.div)(({ }) => ({
    height: "100vh"
}));